import { CircularProgress } from "@mui/material";
import { Grid } from "../../components/grid/Grid";
import { SPACING } from "../../data/spacing";

export const Fallback = () => {
  return (
    <Grid mt={SPACING.MEDIUM}>
      <CircularProgress color="primary" />
    </Grid>
  );
};
